import React from "react";

/**
 * Renders an embed for YouTube or Vimeo URLs.
 * Supported patterns:
 *  - https://www.youtube.com/watch?v=ID
 *  - https://youtu.be/ID
 *  - https://vimeo.com/ID
 */
export default function VideoEmbed({ url, title = "Vídeo", className = "" }) {
  if (!url) return null;
  const clean = url.trim();
  let src = null;

  const yt1 = clean.match(/youtube\.com\/watch\?v=([\w-]+)/);
  const yt2 = clean.match(/youtu\.be\/([\w-]+)/);
  const yt3 = clean.match(/youtube\.com\/embed\/([\w-]+)/);
  const vim = clean.match(/vimeo\.com\/(\d+)/);

  if (yt1) src = `https://www.youtube.com/embed/${yt1[1]}`;
  else if (yt2) src = `https://www.youtube.com/embed/${yt2[1]}`;
  else if (yt3) src = clean;
  else if (vim) src = `https://player.vimeo.com/video/${vim[1]}`;

  if (!src) return null;

  return (
    <div className={`relative w-full overflow-hidden rounded-2xl bg-stone-900 ${className}`} style={{ aspectRatio: "16 / 9" }}>
      <iframe
        src={src}
        title={title}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className="absolute inset-0 h-full w-full border-0"
      />
    </div>
  );
}
